/**
 * Copyright (c) 2024 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : Header.jsx
 * description   : {{insert here}}
 * creation date : 01/02/2024
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    Fragment,
} from 'react';

import {
    View,
} from '@aws-amplify/ui-react';

import {
    useComponentContext,
} from '@/components/core';

import {
    BrandLogo,
    brand_logo_variant,
    brand_logo_color,
} from '@/components/snippets/BrandLogo';



// --------------------------------------------------------------------------------
//      FUNCTIONS
// --------------------------------------------------------------------------------

function Header() {
    // Component context
    const { ctx } = useComponentContext();

    return (
        <Fragment>
            <View
                className='authenticator-header'
            >
                <BrandLogo
                    height={ctx.theme.tokens.fontSizes.xxxl}
                    logoVariant={brand_logo_variant.horizontal}
                    logoColor={brand_logo_color.dark}
                />
            </View>
        </Fragment>
    );
}



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export default Header;



// End of file
